import React from "react";

import { splitStringToParagraphs } from "~utils/helpers";

const PrimaryText = ({ text, textColour = "orange" }) => {
  return (
    <section className={`primary-text grid text-${textColour}`}>
      <article className="grid-end-12 mt-v7 xs:mt-v28 mb-v7 xs:mb-v14">
        {splitStringToParagraphs(text, `mb-v3 xs:mb-v6 universal-sans f2`)}
      </article>
    </section>
  );
};

export default PrimaryText;
